export const getVehicleParams = (linkConfiguration = '', vehicleData = {}) =>
	linkConfiguration
		.split(' ')
		.flatMap((item) => {
			const key = item === 'bodystyle' ? 'gvBodyStyle' : item;
			const value = vehicleData[item];
			return value ? [`${key}=${encodeURIComponent(value)}`] : [];
		})
		.join('&');
